import colorwayMerch from './colorwayMerch'
import type { IWhiteboardTemplate } from './IWhiteboardTemplate'
import LevisMensBottomsRTFinish from './LevisMensBottomsRTFinish'
import standard from './standard'
import visualLineBuilder from './visualLineBuilder'
import GraphicTeeTechSheet from './graphicTeeTechSheet'
import ApparelTechSheet from './apparelTechSheet'
import FootwearTechSheet from './footwearTechSheet'
import AccessoriesTechSheet from './accessoriesTechSheet'

// TODO: Might need to load them dynamically

const templates: Record<number, IWhiteboardTemplate> = {}
templates[standard.id] = standard
templates[visualLineBuilder.id] = visualLineBuilder
templates[colorwayMerch.id] = colorwayMerch
templates[LevisMensBottomsRTFinish.id] = LevisMensBottomsRTFinish
templates[GraphicTeeTechSheet.id] = GraphicTeeTechSheet
templates[ApparelTechSheet.id] = ApparelTechSheet
templates[FootwearTechSheet.id] = FootwearTechSheet
templates[AccessoriesTechSheet.id] = AccessoriesTechSheet

export default templates
